import { Text } from '@loadsmart/loadsmart-ui'

import { calculateRatePerMile } from 'core/domain/LaneRate'
import { formatRate } from 'core/presenters/laneRatePresenter'

import { getRateValue, hasRatePerMile } from '../domain/Rate'

/**
 * Values with prefix `current` are the ones that the user typed on the input fields (Those will have values only when user is bidding on the quote)
 * Values with prefix `initial` are the ones that the user submitted for the quote
 */
export type SubmittedRateValueProps = {
  currentFlatRate?: number
  initialFlatRate: number
  initialPerMileRate: number
  mileage?: number
}

export function SubmittedRateValue({
  currentFlatRate,
  initialFlatRate,
  initialPerMileRate,
  mileage,
}: SubmittedRateValueProps) {
  let currentRatePerMile: number | undefined
  if (currentFlatRate && mileage) {
    currentRatePerMile = calculateRatePerMile(currentFlatRate, mileage)
  }

  const flatRate = getRateValue(initialFlatRate, currentFlatRate)
  const ratePerMile = getRateValue(initialPerMileRate, currentRatePerMile)
  const calculatedRate = formatRate(flatRate, false, '$')
  const calculatedRatePerMile = formatRate(ratePerMile, true, '$')
  const hasRPM = hasRatePerMile(Number(ratePerMile), mileage)

  if (!hasRPM) {
    return <Text variant="body-bold">Submitted bid {calculatedRate}</Text>
  }

  return (
    <Text variant="body-bold">
      Submitted bid {calculatedRate} ({calculatedRatePerMile}/mi)
    </Text>
  )
}
